import { NavItemData } from 'domains/Shell/NavBar/NavBar';
import baseApi from './baseApi';

export type SiteInfo = {
  logoHref: string;
  logoImageSrc: string;
  siteId: string;
  siteName: string;
};

type SiteNavigation = {
  mainNav: NavItemData[];
};

type Colors = {
  theme: {
    primaryColor: string;
    secondaryColor: string;
  };
};

type SiteTrackingSettings = {
  conversionTrackingRegistration?: string;
  pixelTrackingHeader?: string;
  pixelTrackingBody?: string;
};

type SiteSettings = {
  externalTeamsEnabled?: boolean;
  appCreateLocation?: boolean;
  childBirthDateRequired?: boolean;
  childEmailEnabled?: boolean;
  hideGender?: boolean;
};

// Define a service using a base URL and injected endpoints
export const siteInfoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSiteIdBySubdomain: builder.query<string, string>({
      query: (subdomain) => `/api/sites/subdomains/${subdomain}`,
      transformResponse: (siteInfo: SiteInfo) => {
        return siteInfo.siteId;
      },
    }),
    getSiteInfoBySubdomain: builder.query<SiteInfo, string>({
      query: (subdomain) => `/api/sites/subdomains/${subdomain}`,
    }),
    getSiteNavigation: builder.query<SiteNavigation, string | null>({
      query: (siteId) => `/api/sites/${siteId}/shell/navigation`,
    }),
    getSiteThemeColors: builder.query<Colors, string | undefined>({
      query: (siteId) => `/api/theme/sites/${siteId}/branding-theme`,
    }),
    getSiteTrackingSettings: builder.query<
      SiteTrackingSettings,
      { siteId: number }
    >({
      query: ({ siteId }) => `/api/sites/${siteId}/trackingSettings`,
    }),
    getSiteSettings: builder.query<SiteSettings, number>({
      query: (siteId) => `/api/sites/${siteId}/settings`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSiteIdBySubdomainQuery,
  useGetSiteInfoBySubdomainQuery,
  useGetSiteNavigationQuery,
  useGetSiteThemeColorsQuery,
  useGetSiteTrackingSettingsQuery,
  useGetSiteSettingsQuery,
} = siteInfoApi;
